import { FunctionComponent, PropsWithChildren } from 'react'
import { useDateConfigs } from 'hooks/date/useDateConfigs'

interface Props extends PropsWithChildren {}

export const DefaultConfigAssigner: FunctionComponent<Props> = ({ children }) => {
  useDateConfigs()

  return <>{children}</>
}
